import React from 'react';
import styled from 'styled-components';
import ShalakaGrid from './ShalakaGrid';
import useLocale from '../../hooks/useLocale';

const Container = styled.section`
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
`;

const GridHeader = styled.header`
  margin-top: ${p => p.theme.spacing[4]}px;
  margin-bottom: ${p => p.theme.spacing[5]}px;
`;

const HeaderTitle = styled.h2`
  font-family: 'Noto Sans Tamil', 'Playfair Display', Georgia, serif;
  font-size: 20px;
  color: #8B4513;
  margin: 0 0 ${p => p.theme.spacing[2]}px;
`;

const HeaderPrompt = styled.p`
  font-family: 'Noto Sans Tamil', ${p => p.theme.typography.fontFamily};
  font-size: 14px;
  color: ${p => p.theme.colors.text.secondary};
  margin: 0;
  line-height: 1.6;
`;

const LiveRegion = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
`;

const GridView = ({ data, onCellTapped, lang }) => {
  const t = useLocale(lang, 'ramaShalaka');

  return (
    <Container>
      <GridHeader>
        <HeaderTitle>{t.gridTitle || "Sri Rama's Guidance"}</HeaderTitle>
        <HeaderPrompt>
          {t.gridPrompt || 'Hold your question in mind, and tap any cell'}
        </HeaderPrompt>
      </GridHeader>

      <LiveRegion aria-live="polite" id="rama-shalaka-announcer" />

      <ShalakaGrid
        grid={data.grid}
        gridTa={data.grid_ta}
        paths={data.paths}
        onReadingRevealed={onCellTapped}
      />
    </Container>
  );
};

export default GridView;
